<template>
  <div style="background: #efeff4;">
    <div class="top">
      <img :src="hospitalInfo.iconUrl" class="icon" alt="" />
      <div class="info">
        <div style="margin-top:17px;">
          <span style="font-weight: bold;font-size:17px;">{{
            hospitalInfo.hospitalName
          }}</span>
        </div>
        <div
          style=" display:inline-block;margin-top:8px;font-size:14px;background-color: #f1f1f1;border-radius: 4px;"
        >
          {{ hospitalInfo.levelName }}
        </div>
        <div style="height:29px;margin:8px 0 5px 0;font-size:14px;">
          {{ hospitalInfo.address }}
        </div>
      </div>
    </div>
    <div style="margin-top:9px;">
      <ph-tabs
        v-model="activeName"
        :list="[{ name: '路线公交' }, { name: '来院导航' }]"
      />
      <div
        v-if="activeName === 0"
        style="padding:1rem; color:#999;background: white;"
      >
        {{ hospitalInfo.trafficroutes }}
      </div>
      <div v-else class="position-view">
        <img
          :src="require('@assets/img_navigation_map.png')"
          style="width: 70%;"
          alt=""
        />
        <div @click="gotoNavigation" style="margin-top: 2rem;">
          <van-icon name="location-o" />
          点击进行导航
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {
      activeName: 0,
      hospitalInfo: {}
    };
  },
  created() {
    this.$http.post(this.$api.REFERENCE_HOSPITAL_INFO).then(res => {
      this.hospitalInfo = res;
    });
  },
  methods: {
    ...mapActions("home", ["getHospitalConfig"]),
    setWxConfig(res) {
      const that = this;
      this.$wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.appId, // 必填，公众号的唯一标识
        timestamp: res.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.nonceStr, // 必填，生成签名的随机串
        signature: res.signature, // 必填，签名
        jsApiList: ["getLocation"] // 必填，需要使用的JS接口列表
      });
      this.$wx.ready(function() {
        that.startLocation();
      });
      this.$wx.error(function(error) {
        that.$toast(error.message);
      });
    },
    startLocation() {
      this.$wx.getLocation({
        type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function(res) {
          const latitude = String(res.latitude).substr(0, 7); // 纬度，浮点数，范围为90 ~ -90
          const longitude = String(res.longitude).substr(0, 7); // 经度，浮点数，范围为180 ~ -180。
          const mapUrl =
            "http://api.map.baidu.com/direction?origin=:" +
            latitude +
            "," +
            longitude +
            "|我的位置&destination=福建中医药大学附属龙岩人民医院" +
            "&mode=driving&region=福州'+'&output=html" +
            "&coord_type=wgs84&src=易就医";
          window.location.href = mapUrl;
        }
      });
    },
    gotoNavigation() {
      this.getHospitalConfig().then(res => {
        this.setWxConfig(res);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.top {
  display: flex;
  height: 124px;
  background-color: white;
}
.icon {
  width: 100px;
  min-width: 100px;
  height: 100px;
  margin: 12px 15px 0 15px;
  border-radius: 1px;
}
.position-view {
  padding: 4rem 0;
  text-align: center;
  background: white;

  > div {
    color: #108ee9;
  }
}
</style>
